import React, {useContext} from 'react';
import styled from "styled-components";
import {UserContext} from "@providers/user";
import {FilterContext} from "@providers/filters";
import {getCityURL} from "@models/district";
import SearchWithoutResult from "@molecules/lotties/search_without_result";
import Icon from "@atoms/icon";
import ButtonBase from "@atoms/button.base";
import ButtonLink from "@atoms/button.link";
import RealtorsProminentsSlider from "@molecules/realtor/prominents_slider";
import {isEmpty} from "@helpers/helpers";
import SearchIcon from "@icons/search.svg";
import AlarmIcon from "@icons/alarm.svg";
import PlusIcon from "@icons/plus.svg";
import NoPropertyIcon from "@icons/no-property.svg";
import NoBookmarkIcon from "@icons/no-bookmark.svg";

const SearchNoResults = ({categories, selectedCity, isBadeSaba = false, selectedFiltersDistrictIds, setInvestModalShow}) => {
    const userContext = React.useContext(UserContext);
    const filters = useContext(FilterContext);

    const handleSelectedRealtorsTitle = () => {
        let title = 'مشاورین املاک منتخب ';

        const {district_id} = filters.selected_filters;

        let districtsNames = '';
        if (!isEmpty(district_id)) {
            if (district_id.length === 1) {
                districtsNames = district_id[0].label;
            } else if (district_id.length > 1) {
                districtsNames = 'در محدوده جستجو';
            }
        }

        if (isEmpty(districtsNames) && !isEmpty(selectedCity)) {
            districtsNames = selectedCity.name
        }

        title += districtsNames;
        let description = 'مشاورین ' + districtsNames + '، فایل‌هایی دارن که هنوز فرصت نکردن آگهی کنن. با مشاورین منتخب تماس بگیرین تا ملک مورد نظرتون رو پیدا کنین.';

        return {
            title: title,
            description: description
        }
    };

    const selectedRealtorsTitles = handleSelectedRealtorsTitle();

    return (
        <NoResults id="propertiesNoResult" className="mb-40 mb-lg-56">
            <div className="container text-center">
                <div className="no-result-gif d-inline-block">
                    {
                        (categories === 'follow') ?
                            <Icon className="mt-24 mt-lg-0"><NoBookmarkIcon/></Icon>
                            :
                            (
                                (categories === 'my_properties') ?
                                    <Icon className="mt-24 mt-lg-0"><NoPropertyIcon/></Icon>
                                    :
                                    <SearchWithoutResult/>
                            )
                    }
                </div>

                {
                    (categories === 'my_properties') ?
                        <React.Fragment>
                            <h3>شما هنوز آگهی‌ای ثبت نکردید!</h3>
                            <p>روزانه هزاران مشتری در ۲نبش، در جستجوی ملک مورد نظرشون هستند.</p>

                            <a href="/ثبت/ملک" className="btn btn-secondary mt-16">
                                <Icon width={16} height={16} className="ml-8"><PlusIcon/></Icon>
                                ثبت رایگان آگهی
                            </a>
                        </React.Fragment>
                        :
                        (
                            (categories === 'follow') ?
                                <div className="pb-16">
                                    <h3>شما هنوز آگهی‌ای رو نشان نکردید!</h3>
                                    <p>از طریق آیکن «نشان‌کردن» می‌تونید آگهی‌های مورد نظرتون رو در این لیست ذخیره کنید.</p>

                                    <ButtonLink href="/properties" hrefAs={(!isEmpty(selectedCity) ? getCityURL(selectedCity.name) : '/')} color="secondary" className="mt-16">
                                        <Icon width={16} height={16} className="ml-8"><SearchIcon/></Icon>
                                        جستجو کنید
                                    </ButtonLink>
                                </div>

                                :

                                <React.Fragment>
                                    <h3>موردی با این مشخصات پیدا نشد!</h3>

                                    {
                                        (!isEmpty(userContext) && !isEmpty(userContext.modality) && userContext.modality.show_invest) ?
                                            <React.Fragment>
                                                <p>هر آگهی جدیدی که با این شرایط‌ ثبت شد:</p>
                                                <ButtonBase onClick={() => setInvestModalShow()} color="secondary" className="mt-16">
                                                    <Icon width={16} height={16} className="ml-8 alarm-icon"><AlarmIcon/></Icon>
                                                    به من اطلاع بده
                                                </ButtonBase>
                                            </React.Fragment>
                                            : ''
                                    }
                                </React.Fragment>
                        )
                }
            </div>

            {
                (!isBadeSaba && !isEmpty(filters.selected_filters) && !isEmpty(filters.selected_filters.city_id) && categories === 'search') ?

                    <div className="container sm-fluid">
                        <div className="selected-realtors">
                            <div className="px-24 px-lg-0">
                                <h2 className="">{selectedRealtorsTitles.title}</h2>
                                <p className="mt-8">{selectedRealtorsTitles.description}</p>
                            </div>

                            <div className="mt-24">
                                <RealtorsProminentsSlider
                                    city_id={filters.selected_filters.city_id}
                                    district_id={selectedFiltersDistrictIds}
                                />
                            </div>
                        </div>
                    </div>
                    : ''
            }
        </NoResults>
    );
};

function propsAreEqual(prevProps, nextProps) {
    return ((prevProps.categories === nextProps.categories) || (JSON.stringify(prevProps.selectedFiltersDistrictIds) === JSON.stringify(nextProps.selectedFiltersDistrictIds)));
}

export default React.memo(SearchNoResults, propsAreEqual);

// styles

const NoResults = styled.div`

  .selected-realtors {
    margin-top: 80px;

    @media (max-width: ${props => props.theme.screenXsMax}) {
      margin-top: 64px;
    }
  }

  .no-result-gif {
    width: 300px;
    height: 300px;

    @media (max-width: ${props => props.theme.screenXsMax}) {
      width: 200px;
      height: 200px;
    }
  }

  .alarm-icon {
    svg {
      g {
        stroke-width: 2;
      }
    }
  }
`;

